import { ref, computed } from 'vue';
import { useCreateListStore } from '#stores/createList';
import { getUserGuid } from '#utils/UserDetails';

export default function useCreateWishlist() {
  const createListStore = useCreateListStore();
  const isCreatingWishlist = ref(false);
  const headers = { 'x-requested-with': 'XMLHttpRequest' };

  const createListResponse = computed(() => createListStore.createListResponse);
  const createWishlistError = computed(() => createListStore.createListError);
  const createListErrorDetails = computed(() => createListStore.createListErrorDetails);

  const newWishlist = computed(() => createListResponse.value?.list?.[0]);
  const newWishlistGuid = computed(() => newWishlist.value?.listGuid || '');
  const newWishlistName = computed(() => newWishlist.value?.name || '');

  const createWishlist = async ({ listName, isPublic }) => {
    isCreatingWishlist.value = true;
    const payload = {
      CustomerList: {
        list: [
          {
            listType: 'w',
            name: listName,
            searchable: !!isPublic,
          },
        ],
        user: { guid: getUserGuid() },
      },
    };
    try {
      await createListStore.createList({ headers, payload });
    } finally {
      isCreatingWishlist.value = false;
    }
  };

  return {
    isCreatingWishlist,
    createWishlistError,
    createListErrorDetails,
    createWishlist,
    newWishlist,
    newWishlistGuid,
    newWishlistName,
  };
}
